import type { FC } from 'react';

import {
    SectionContainer,
    SectionDescription,
    SectionTitle,
    SectionCard,
} from './styled';

interface IProfileSection {
    title: string;
    description: string;
}

export const ProfileSection: FC<IProfileSection> = ({
    title,
    description,
    children,
}) => (
    <SectionContainer>
        <div>
            <SectionTitle bold>{title}</SectionTitle>
            <SectionDescription>{description}</SectionDescription>
        </div>
        <SectionCard>{children}</SectionCard>
    </SectionContainer>
);
